export enum OS {
  IOS = "ios",
  ANDROID = "android",
  OTHER = "other",
}
